import Vue from 'vue';
import api from "@/service/api";

export class ServerCommon {

  public static getUid(): Promise<any> {

    return new Promise((resolve, reject) => {

      // Vue.axios({
      //   url: 'v1/auth/get-uid',
      //   method: 'GET',
      // })
        api.go('getDeviceId')
        .then((resp: any) => {
          resolve(resp.data.uid);
        })
        .catch((err: any) => {
          reject(err);
        });

    })

  }
}

